<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10yVum3/tc-custom/9781625846891.jpg?1705203638748" alt="This image is the cover for the book Haunted Tampa, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Tampa, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Explore the spirited history and haunted sites of Tampa with this guide from a local historian.</b></p> Tampa may be known for sunshine and good times, but it has a scary side. When dusk settles down over the Hillsborough River, spirits begin to stir. Strange things happen in old hotels, theaters and public buildings, and an old cemetery becomes surprisingly lively. Some have seen an old crime boss walking the street. Some have encountered ancient spirits in a public parking garage. Still others have met a long-dead soul in a downtown shop. Join local author and historian Deborah Frethem as she navigates the twists and turns of the more macabre side of Tampa Bay.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Frethem
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?018c254e